import { render } from "./news.vue?vue&type=template&id=213b357e&scoped=true"
const script = {}

import "./news.vue?vue&type=style&index=0&id=213b357e&lang=less"
import "./news.vue?vue&type=style&index=1&id=213b357e&scoped=true&lang=less"

import exportComponent from "/Users/jizhengliang/Desktop/octopus/edu/educms-vue/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-213b357e"]])

export default __exports__